import dayjs from 'dayjs';

/**
 * 기준 날짜로부터 지정된 단위와 숫자만큼 이동한 날짜를 반환하는 함수
 * @param n 더할 숫자
 * @param unit 날짜 단위 ('day', 'week', 'month', 'year')
 * @param date 기준 날짜 (기본값: 현재 날짜)
 * @returns 계산된 날짜
 */
const getDateByOffset = (n: number, unit: 'day' | 'week' | 'month' | 'year', date: Date = new Date()): Date => {
  return dayjs(date).startOf('day').add(n, unit).toDate();
};

export default getDateByOffset;
